import React, { useContext, useEffect } from 'react';
import { TranslationContext } from './Context';


const SkuDropdown = props => {
    const translations = useContext(TranslationContext);

    useEffect(() => {
        if (props.options && props.options.length === 1) {
            props.onChange(props.options[0].key);
        }
    });

    const callOnChange = (event) => {
        props.onChange(event.target.value);
    };

    return (
        <div className="variantPickerComponent-select">

            <label className="variantPickerComponent-label" htmlFor={props.id}>{props.label}</label>

            <select className="variantPickerComponent-dropdown form-control" id={props.id} placeholder={props.label} value={props.selectedValue} onChange={callOnChange.bind(this)}>
                <option value="default" selected disabled hidden>{translations["VariantPicker.DropdownSelectText"]}</option>
                {
                    props.options !== null &&
                    Object.keys(props.options).map((x) => (
                        <option value={props.options[x].key}>{props.options[x].value}</option>
                    ))
                }
            </select>
        </div>
    );
};

export default SkuDropdown;